import SelectUserDropdown from '../../../../components/global-components/selectUserDropdown';
import SelectSubAccountDropdown from '../../../../components/global-components/selectSubAccountDropdown';
import SelectProjectDropdown from '../../../../components/global-components/SelectProjectDropdown';
import { Button, DropdownTemp } from '../../../../components';
import { useShipmentReport } from '../../hooks';
import {
  canceledOptions,
  deliveredOptions,
  shipmentModes,
  shipmentTypes,
} from '../../constants';
import { DateRangePicker, Loading, RadioButton } from '../';

interface Props {
  isAdmin: boolean;
}

export default function ShipmentReportFilters({ isAdmin }: Props) {
  const {
    isLoading,
    startDate,
    endDate,
    onChangeCreatedDates,
    account,
    onChangeAccount,
    username,
    onChangeUser,
    projectCode,
    onChangeProject,
    shipmentMode,
    onChangeShipmentMode,
    shipmentType,
    onChangeShipmentType,
    deliveredRadio,
    onChangeIsDelivered,
    canceledRadio,
    onChangeIsCanceled,
    clearFilters,
    onClickDownload,
  } = useShipmentReport(isAdmin);

  return (
    <div className='d-flex flex-column gap-4'>
      {isLoading ? <Loading /> : ''}
      <DateRangePicker
        label='Created Date'
        startDate={startDate}
        endDate={endDate}
        onChangeDates={onChangeCreatedDates}
        required={true}
      />
      {isAdmin && (
        <SelectSubAccountDropdown
          setSelectedSubAccount={onChangeAccount}
          selectedSubAccount={account}
          label='Account'
          firstOption='All Accounts'
        />
      )}
      <SelectUserDropdown
        label='User'
        selectedUserName={username}
        setSelectedUserName={onChangeUser}
        isAdmin={isAdmin}
      />
      <SelectProjectDropdown
        selectedProject={projectCode}
        setSelectedProject={onChangeProject}
        setHandleToggleChange={() => {}}
        label='Projects'
      />
      <DropdownTemp
        id='shipment-type-dropdown'
        options={shipmentTypes}
        value={shipmentType}
        setValue={onChangeShipmentType}
        label='Shipment Type'
      />
      <DropdownTemp
        id='shipment-mode-dropdown'
        options={shipmentModes}
        value={shipmentMode}
        setValue={onChangeShipmentMode}
        label='Shipment Mode'
      />
      <RadioButton
        name='delivered-shipments'
        label='Deliverd Shipments?'
        selectedValue={deliveredRadio}
        setSelectedValue={onChangeIsDelivered}
        radioOptions={deliveredOptions}
      />
      <RadioButton
        name='cancel-shipments'
        label='Canceled Shipments?'
        selectedValue={canceledRadio}
        setSelectedValue={onChangeIsCanceled}
        radioOptions={canceledOptions}
      />
      <div className='d-flex flex-column gap-2 align-items-center pt-4'>
        <Button
          text='Download'
          onClick={onClickDownload}
          disabled={isLoading}
        />
        <Button
          text='Clear'
          onClick={clearFilters}
          disabled={isLoading}
        />
      </div>
    </div>
  );
}
